import apiClient from "../api";

const AccountHistoricDocumentService = {
  /**
   * Récupérer les documents d'un AccountHistoric spécifique
   */
  getAccountHistoricDocuments: async (historicId, domainId) => {
    try {
      const response = await apiClient.get(
        `/api/TransactionDocuments/account-historic/${historicId}/documents`,
        { params: { domainId } }
      );
      return response.data;
    } catch (error) {
      // console.error('Erreur récupération documents historic:', error);
      throw new error;
    }
  },

  /**
   * Récupérer tous les historics avec documents d'un compte
   */
  getAccountHistoricsWithDocuments: async (accountId, domainId, filters = {}) => {
    try {
      const params = {
        domainId,
        ...filters
      };
      
      const response = await apiClient.get(
        `/api/TransactionDocuments/account/${accountId}/account-historics-documents`,
        { params }
      );
      return response.data;
    } catch (error) {
      // console.error('Erreur récupération historics avec documents:', error);
      throw new error;
    }
  }
};

export default AccountHistoricDocumentService;